import { deepMerge } from "@std/collections/deep-merge";
import { DEFAULT_SETTINGS } from "./default";
import { AppSettings } from "./types";

export const SETTINGS: AppSettings = deepMerge(DEFAULT_SETTINGS, window.settings || {});
